import { render, staticRenderFns } from "./TermUpdate.vue?vue&type=template&id=2357dc57&scoped=true&"
import script from "./TermUpdate.vue?vue&type=script&lang=js&"
export * from "./TermUpdate.vue?vue&type=script&lang=js&"
import style0 from "./TermUpdate.vue?vue&type=style&index=0&id=2357dc57&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2357dc57",
  null
  
)

export default component.exports